export default "__VITE_ASSET__e33f2b66__"